// PDF React View
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MODE_INVOICE_ACTION,
  TYPE_ADJUST_INVOICE,
} from "constants/IssueInvoiceConstant";
import { generateSelectField } from "helpers/form_helper_old";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { options } from "toastr";
import * as yup from "yup";
import { changeYearOfSerial } from "../utils";
const ConfirmActionInvoice = props => {
  const dispatch = useDispatch();
  const {
    isOpen,
    toggle,
    confirmActionData,
    typeInvoiceAnother,
    actionReplaceOrAdjustInvoice,
    isTaxDeduct = false,
  } = props;

  const issueInvoice = useSelector(state => state.issueInvoice);
  const { currentTime } = issueInvoice;

  useEffect(() => {
    if (isOpen) {
      setValue("pattern", {
        value: confirmActionData.pattern,
        label: confirmActionData.pattern,
      });
      const serial = confirmActionData.serial;
      //
      setValue("serial", {
        value: serial,
        label: serial,
      });
      setValue("invoiceNo", confirmActionData.invoiceNo);

      switch (confirmActionData.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          setValue("isAdjust", false);
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          setValue("isAdjust", true);
          break;
        default:
          break;
      }
    } else {
      reset();
    }
  }, [isOpen]);

  const schema = yup.object().shape({
    isAdjust: yup.boolean(),
    pattern: yup.object().required("Vui lòng chọn mẫu số"),
    serial: yup.object().required("Vui lòng chọn ký hiệu"),
    invoiceNo: yup.string().required("Vui lòng nhập số hóa đơn"),
    typeAdjust: yup.object().when("isAdjust", {
      is: true, //just an e.g. you can return a function
      then: yup.object().required("Vui lòng chọn kiểu điều chỉnh"),
    }),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const onSubmit = values => {
    let typeAdjust = null;
    typeAdjust = values?.typeAdjust?.value;
    toggle();
    switch (confirmActionData.mode) {
      case MODE_INVOICE_ACTION.REPLACE:
        break;
      case MODE_INVOICE_ACTION.ADJUST:
        break;
      default:
        break;
    }
    // Nếu sang năm thì phải tăng năm
    const finalSerial = changeYearOfSerial(
      confirmActionData.serial,
      currentTime?.data?.year.toString()
    );
    actionReplaceOrAdjustInvoice(typeAdjust, finalSerial);
  };

  const objectAction = isTaxDeduct ? "CTKT" : "Hóa đơn";

  const optionTypeAdjust = [
    {
      value: TYPE_ADJUST_INVOICE.INCREASE,
      label: `${objectAction} điều chỉnh tăng`,
    },
    {
      value: TYPE_ADJUST_INVOICE.DECREASE,
      label: `${objectAction} điều chỉnh giảm`,
    },
    {
      value: TYPE_ADJUST_INVOICE.CHANGE_INFO,
      label: `${objectAction} điều chỉnh thông tin`,
    },
  ];

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ maxWidth: "400px" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>
            Thông tin {objectAction} cần{" "}
            {confirmActionData?.mode === MODE_INVOICE_ACTION.REPLACE
              ? "thay thế"
              : "điều chỉnh"}
          </Label>
        </ModalHeader>

        <React.Fragment>
          <ModalBody>
            <React.Fragment>
              <Row>
                <Col>
                  <Label>Mẫu số </Label>
                  <Controller
                    control={control}
                    name={"pattern"}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isDisabled={true}
                        placeholder={"Vui lòng chọn mẫu số"}
                        options={options}
                        classNamePrefix="select2-selection"
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  <Label>Ký hiệu </Label>
                  <Controller
                    control={control}
                    name={"serial"}
                    render={({ field }) => (
                      <Select
                        {...field}
                        isDisabled={true}
                        placeholder={"Vui lòng chọn ký hiệu"}
                        options={options}
                        classNamePrefix="select2-selection"
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col>
                  <Label>Số {objectAction}</Label>
                  <input
                    disabled={true}
                    {...register("invoiceNo")}
                    type="text"
                    className={`form-control`}
                    placeholder={`Vui lòng nhập số ${objectAction}`}
                  />
                </Col>
              </Row>
              {confirmActionData?.mode === MODE_INVOICE_ACTION.ADJUST && (
                <Row className="mt-1">
                  <Col>
                    {generateSelectField(
                      "Kiểu điều chỉnh",
                      true,
                      errors,
                      "typeAdjust",
                      "Vui lòng chọn kiểu điều chỉnh",
                      false,
                      control,
                      optionTypeAdjust,
                      "auto"
                    )}
                  </Col>
                </Row>
              )}
            </React.Fragment>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="primary"
              // disabled={listMethodSign.length === 0}
              className="me-2 btn-label"
              onClick={() => {
                handleSubmit(onSubmit)();
              }}
            >
              {confirmActionData?.mode === MODE_INVOICE_ACTION.REPLACE ? (
                <React.Fragment>
                  <i className="bx bx-rotate-left label-icon" />
                  Thay thế {objectAction}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <i className="bx bx-edit label-icon" />
                  Điều chỉnh {objectAction}
                </React.Fragment>
              )}
            </Button>
            <Button
              type="button"
              color="danger"
              className="me-2"
              onClick={toggle}
            >
              Đóng
            </Button>
          </ModalFooter>
        </React.Fragment>
      </div>
    </Modal>
  );
};

ConfirmActionInvoice.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  confirmActionData: PropTypes.any,
  actionReplaceOrAdjustInvoice: PropTypes.func,
  typeInvoiceAnother: PropTypes.any,
  isTaxDeduct: PropTypes.bool,
};

export default ConfirmActionInvoice;
